export default class Http {
  /* global ActiveXObject */
  _createxmlHttpRequest() {
    let xhr
    if (window.ActiveXObject) {
      xhr = new ActiveXObject('Microsoft.XMLHTTP')
    } else if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest()
    }
    return xhr
  }

  // 格式化post 传递的数据
  postDataFormat(obj) {
    if (typeof obj === 'object') {
      var arr = []
      var i = 0
      for (var attr in obj) {
        arr[i] = encodeURIComponent(attr) + '=' + encodeURIComponent(obj[attr])
        i++
      }
      return arr.join('&')
    } else {
      return obj
    }
  }

  get(url, data, callback, error, params = { withCredentials: false }) {
    let xhr = this._createxmlHttpRequest()
    if (data) {
      url += '?' + this.postDataFormat(data)
    }
    xhr.open('GET', url, true)
    xhr.withCredentials = params.withCredentials
    xhr.send(null)
    xhr.onload = function() {
      var data = xhr.response // 服务端返回的数据
      try {
        if (!JSON.parse(data).code) {
          callback(JSON.parse(data))
        } else {
          error(JSON.parse(data))
        }
      } catch (e) {
        console.log(e)
        if (error) {
          error({
            msg: 'Oops! Something went wrong and it was probably our fault. Please try again~',
          })
        } else {
          console.log(e)
        }
      }
    }
    return xhr
  }

  post(url, data, callback, error) {
    let xhr = this._createxmlHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // 以表格数据发送
    xhr.send(this.postDataFormat(data))
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          if (JSON.parse(data).code === 0) {
            callback(JSON.parse(data))
          } else {
            error(JSON.parse(data))
          }
        } catch (e) {
          if (error) {
            error({
              msg: xhr.status + ' error',
            })
          } else {
            console.log(e)
          }
        }
      } else if (xhr.status !== 200) {
        if (error) {
          error(JSON.parse(data))
        }
      }
    }
  }
}
